enum MandateState {
    Active = "ACTIVE",
    PendingInvitation = "PENDING_INITIATION",
    Cancelled = "CANCELLED",
    Rejected = "REJECTED",
    Finished = "FINISHED",
    Returned = "RETURNED"
}
export default MandateState